import React from 'react'
import Tr from 'translations/Translations';
import EditIcon from '@material-ui/icons/Edit'
import WorkableIconButton from "./WorkableIconButton";
import PropTypes from "prop-types";

function WorkableIconEditButton({
	tooltip = Tr('edit'),
	...props
}) {
	return <WorkableIconButton
		tooltip={tooltip}
		Icon={EditIcon}
		{...props}
	/>
}

WorkableIconEditButton.propTypes = {
	expanded: PropTypes.bool,
	working: PropTypes.bool,
	disabled: PropTypes.bool,
	tooltip: PropTypes.string,
	hideTooltip: PropTypes.bool,
	color: PropTypes.string,
	onClick: PropTypes.func
}

export default WorkableIconEditButton;